// extracted by mini-css-extract-plugin
export default {"card":"Card_card__rbBv7","imageSection":"Card_imageSection__+hoE1","section":"Card_section__35QZ3"};